import React from 'react'
import Link from 'next/link'
import Button from 'library/atoms/Button'
import { Text } from 'library/atoms/Typography'
import Icon from 'shared/library/atoms/Icon'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'
import styled from '@emotion/styled'

const StyledSection = styled.section(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  gap: theme.space[3]
}))

const PROPS = {
  Description: () => (
    <>
      <Text as="div">
        <p>
          Buttons allow users to take actions, and make choices, with a single
          tap.
        </p>
        <p>Commonly used operating buttons:</p>
      </Text>
    </>
  ),
  examples: [
    {
      title: 'variant: primary',
      code: `<StyledSection>
  <Button>Primary Button</Button>
  <Button>
    <Icon name="shield" size={24} color="white" mr={2}/>
    Primary Button
  </Button>
  <Button variant="primary" inactive>Primary Button</Button>
  <Button loading>Primary Button</Button>
  <Button success>Primary Button</Button>
</StyledSection>`,
      scope: { Button, StyledSection, Icon }
    },
    {
      title: 'variant: secondary',
      code: `<StyledSection>
  <Button variant="secondary">Secondary Button</Button>
  <Button variant="secondary" inactive>Secondary Button</Button>
  <Button variant="secondary" loading>Secondary Button</Button>
  <Button variant="secondary" success>Secondary Button</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'variant: tertiary',
      code: `<StyledSection>
  <Button variant="tertiary">Tertiary Button</Button>
  <Button variant="tertiary" inactive>Tertiary Button</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'variant: quaternary',
      code: `<StyledSection>
  <Button variant="quaternary">Quaternary Button</Button>
  <Button variant="quaternary" inactive>Quaternary Button</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'variant: content',
      code: `<StyledSection>
  <Button variant="content">Content</Button>
  <Button variant="content" inactive>Content</Button>
  <Button variant="content" loading>Content</Button>
  <Button variant="content" success>Content</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'variant: icon',
      code: `<StyledSection>
  <Button variant="icon">
    <Icon name="close" color="grey" />
  </Button>
  <Button variant="icon" inactive>
    <Icon name="close" color="grey" />
  </Button>
  <Button variant="icon" loading>
    <Icon name="close" color="grey" />
  </Button>
</StyledSection>`,
      scope: { Button, StyledSection, Icon }
    },
    {
      title: 'variant: eola Primary',
      code: `<StyledSection>
  <Button variant="eola-primary">Eola Primary</Button>
  <Button variant="eola-primary" inactive>Eola Primary</Button>
  <Button variant="eola-primary" loading>Eola Primary</Button>
  <Button variant="eola-primary" success>Eola Primary</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'variant: eola Secondary',
      code: `<StyledSection>
  <Button variant="eola-primary">Eola Secondary</Button>
  <Button variant="eola-primary" inactive>Eola Secondary</Button>
  <Button variant="eola-primary" loading>Eola Secondary</Button>
  <Button variant="eola-primary" success>Eola Secondary</Button>
</StyledSection>`,
      scope: { Button, StyledSection }
    },
    {
      title: 'Button with the Link from NextJs',
      code: `<StyledSection>
  <Link href="" passHref href="/">
    <Button as="a">Anchor Link</Button>
  </Link>
  <Link href="" passHref href="/">
    <Button as="a" variant="tertiary">Anchor Link</Button>
  </Link>
</StyledSection>`,
      scope: { Button, Link, StyledSection }
    }
  ]
}

const ButtonStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default ButtonStyleGuide
